import axios from "axios";
import { toast } from "react-toastify";
import { authHeader } from '../../services/base'

export const useCustomAxios = () => {

  const customAxios = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: authHeader()
  });

  customAxios.interceptors.response.use(
    response => response,
    error => {
      return Promise.reject(error)
    },
  );

  return { customAxios }

}